/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from saving scraped content
 * @export
 * @interface ScrapedContentSaveResponse
 */
export interface ScrapedContentSaveResponse {
    /**
     * Number of new items saved (after deduplication)
     * @type {number}
     * @memberof ScrapedContentSaveResponse
     */
    savedCount: number;
    /**
     * Total number of items received in the request
     * @type {number}
     * @memberof ScrapedContentSaveResponse
     */
    totalReceived: number;
}

/**
 * Check if a given object implements the ScrapedContentSaveResponse interface.
 */
export function instanceOfScrapedContentSaveResponse(value: object): value is ScrapedContentSaveResponse {
    if (!('savedCount' in value) || value['savedCount'] === undefined) return false;
    if (!('totalReceived' in value) || value['totalReceived'] === undefined) return false;
    return true;
}

export function ScrapedContentSaveResponseFromJSON(json: any): ScrapedContentSaveResponse {
    return ScrapedContentSaveResponseFromJSONTyped(json, false);
}

export function ScrapedContentSaveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrapedContentSaveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'savedCount': json['saved_count'],
        'totalReceived': json['total_received'],
    };
}

export function ScrapedContentSaveResponseToJSON(json: any): ScrapedContentSaveResponse {
    return ScrapedContentSaveResponseToJSONTyped(json, false);
}

export function ScrapedContentSaveResponseToJSONTyped(value?: ScrapedContentSaveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'saved_count': value['savedCount'],
        'total_received': value['totalReceived'],
    };
}

